export default {
    SYNTHETIC: 'SYNTHETIC',
    COMMON: 'COMMON',
};
